/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kn_TitleInputs */

const cs_kn_title = /** @type {(inputs: Kn_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katastr (KN)`)
};

const en_kn_title = /** @type {(inputs: Kn_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadastre (KN)`)
};

/**
* | output |
* | --- |
* | "Cadastre (KN)" |
*
* @param {Kn_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const kn_title = /** @type {((inputs?: Kn_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kn_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kn_title(inputs)
	return cs_kn_title(inputs)
});